import { twc } from "../utils";

export const ProseH2 = twc.h2`text-base font-semibold text-primary leading-snug mt-4 mb-1.5 first:mt-0`;
export const ProseH3 = twc.h3`text-[0.9375rem] font-semibold text-primary leading-snug mt-3 mb-1.5 first:mt-0`;
export const ProseH4 = twc.h4`text-sm font-semibold text-primary leading-snug mt-3 mb-1 first:mt-0`;

export const ProseP = twc.p`my-4`;
export const ProseHr = twc.hr`border-0 h-px bg-secondary/60 my-3`;
export const ProseBlockquote = twc.blockquote`my-3 py-2 px-3 border-l-3 border-brand-teal bg-secondary/15 rounded-r-md text-text-secondary [&_p]:m-0`;

export const ProseUl = twc.ul`list-none p-0 my-2 flex flex-col gap-1.5`;
export const ProseOl = twc.ol`list-none p-0 my-2 flex flex-col gap-1.5`;
export const ProseLi = twc.li`py-1.5 px-3 bg-secondary/20 rounded-lg leading-[1.4]`;

export const ProseStrong = twc.strong`font-semibold text-primary`;
export const ProseEm = twc.em`italic`;
export const ProseInlineCode = twc.code`font-mono text-[0.85em] py-0.5 px-1.5 bg-secondary/30 rounded`;
export const ProsePre = twc.pre`my-3 py-3 px-4 bg-secondary/20 rounded-lg overflow-x-auto text-[0.8125rem] leading-relaxed font-mono`;

export const ProseTable = twc.table`w-full border-collapse-separate border-spacing-0 rounded-xl overflow-hidden text-sm leading-normal my-3 border border-secondary/50`;
export const ProseThead = twc.thead`bg-secondary/40`;
export const ProseTh = twc.th`py-2.5 px-4 text-left font-semibold text-primary text-[0.8125rem] tracking-wide uppercase`;
export const ProseTd = twc.td`py-2 px-4 border-t border-secondary/30`;
export const ProseTbody = twc.tbody`[&_tr:hover]:bg-secondary/30`;

export const ProseLink = twc.a`text-brand-teal underline underline-offset-2 decoration-1 hover:opacity-80`;
